import Button from "./common/Button";
import Title from "./common/Title";
import aboutmay from "../img/aboutmay.png"; 

export default function AboutMay() {
    return <>
        <div className="aboutmay skew">
            <div className="container py-5 skew-rev" >
                <div className="row align-items-center pb-0 pb-lg-5" >
                    <div className="col-lg-6 pe-xl-5 pt-lg-5 mt-lg-4 pt-4 pt-lg-0" >
                    <Title 
                        titleclass="md text-dark text-center text-lg-start"
                        title={<><strong className="fill" >About </strong> Mayweather <br></br>
                             BOXING <b className="redcolor" >+</b> <strong>FITNESS</strong></>}
                        des="An Inner Champion lives inside us all, waiting to be released. Mayweather Boxing + Fitness offers an authentic experience for those who want to learn from Floyd’s techniques and training regimens, while getting in the best shape of their lives in a high-intensity group fitness setting. Become part of our tight-knit community, and build the strength, confidence and passion needed to triumph in any fight that life presents."
                        desclass='my-3 text-dark  text-center text-lg-start' />
                    <Button text={"Contact Us"} cls="btn btn-primary m-auto m-lg-0 d-table mt-5 " />
                    </div>
                    <div className="col-lg-6 ps-xl-5 pt-4 pt-lg-0" >
                        <img src={aboutmay} className="img-fluid" alt="aboutmay" />
                    </div>
                </div>
            </div>
        </div>
    </>
}